import { rem } from '@heathmont/moon-utils';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';
import PageTitle from '~/client/shared/PageTitle';
import Stack from '~/client/shared/Stack';
import TournamentSection from '../../shared/TournamentSection';

const Tournaments: FC = () => {
  const { user } = useCurrentUser();
  return (
    <Stack maxWidth={rem(1172)} space="medium" margin="0 auto">
      <PageTitle translateId="game-leaderboard.tournaments" />
      <Stack space={rem(44)}>
        {user?.id && <TournamentSection onlyMine />}
        <TournamentSection status="current" />
        <TournamentSection status="future" />
        <TournamentSection status="past" />
      </Stack>
    </Stack>
  );
};

export default Tournaments;
